import { SyntheticEvent } from 'react'
import { KedoContext } from '../model/types'

export const useEnvironmentInfo = (kedo: KedoContext) => {
    const envService = kedo.env()

    const environment = envService.getEnvironment()
    const environmentName = envService.getEnvironmentName()

    const handleImageError = (ev: SyntheticEvent<HTMLImageElement>) => {
        ev.currentTarget.src = '/static/images/xlab-logo.jpg'
    }

    const clearEnvironment = () => {
        localStorage.removeItem('environment')
        envService.clearInfo()
    }

    const logoSrc = environment?.id
        ? `/images/environment/${environment.id}/logo.png`
        : '/static/images/xlab-logo.jpg'

    return {
        environment,
        environmentName,
        logoSrc,
        handleImageError,
        clearEnvironment,
    }
}